import React, { Component } from 'react';
import { Button, Col } from 'reactstrap';
import { authInstance } from '../login/AuthService';

class ProcessButton extends Component{
    constructor(props) {
        super(props);
        this.props.onRef(this);
        this.bearerToken = authInstance.getToken();
        this.toggleButton = this.toggleButton.bind(this);
        this.loading = this.props.loading.bind(this);
        this.noGraph = this.props.noGraph.bind(this);
        this.graph = this.props.graph.bind(this);
        this.pointAddress = this.props.pointAddress;
        this.pointValue = this.props.pointValue;
        this.pointOperator = this.props.pointOperator;

        this.state = {
            disable: true
        }
    }

    toggleButton(value){
        this.setState({
            disable: value
        });
    }
    
    processData = () =>{
        this.noGraph(false);
        this.loading(true);
        const formData = new FormData();
        var file = document.getElementById('csvInput').files[0];
        var pointAddress = this.pointAddress;
        var pointValue = this.pointValue;
        var pointOperator = this.pointOperator;
        var csvDate = new Date(file.lastModified).toLocaleString();
        var clientId = document.getElementsByName("client-dropdown")[0].value;

        formData.append('EMSFile', file);
        formData.append('EMSPointAddressIndex', pointAddress);
        formData.append('EMSPointValueIndex', pointValue);
        formData.append('EMSPointOperatorIndex', pointOperator);
        formData.append('EMSExportDate', csvDate);
        formData.append('ClientId', clientId);
        
        this.setState({ isBusy: true }, () => {

            //fetch(`https://simulateapiprod.azurewebsites.net/api/predict/processfileasync`, {
            fetch('https://astcloudrestservice.azurewebsites.net/api/predict/processfileasync',{
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.bearerToken}`
                    },
                body: formData,
            }).then(results => {
                return results.json();
            }).then(data => {
                this.loading(false);
                this.graph(true, data);
                this.toggleButton(true);
            })
            .catch(
                error => console.log(error)
            );
        })
    }

    render(){
        return(
            <Col lg="12" className="Process-Button-Placement">
                <Button color="primary" className="Process-Button" disabled={this.state.disable} onClick={this.processData}>Process</Button>
            </Col>
        );
    }
}
export default ProcessButton;